import React from 'react';
import PropTypes from 'prop-types';
import NBSLink from '../../NBS/index';
import { getFlowType } from '../../../common/Helpers';

const NextBillSummary = (props) => {
  const { estimatedBillSummary, estimatedBillDescriptionLTE, estimatedBillDescription5G } = props;
  const flowType = getFlowType();
  
  return (
    <NBSLink
      pageName={props?.pageName}
      dueMonthlyLabel={estimatedBillSummary}
      monthlySurchargesText={flowType === 'LTE' ? estimatedBillDescriptionLTE : estimatedBillDescription5G}
    />
  );
};

NextBillSummary.propTypes = {
  estimatedBillSummary: PropTypes.string,
  estimatedBillDescriptionLTE: PropTypes.string,
  estimatedBillDescription5G: PropTypes.string,
  pageName: PropTypes.string,
};

export default NextBillSummary;
